import { AppProvider } from "../maps/context/context";
import { NavTypeProps } from "../maps/MapsIndex";
import Maps from "./Maps";

const DashBoardIndex = (props: NavTypeProps) => {
  return (
    <AppProvider>
      <Maps {...props} />
    </AppProvider>
  );
};

export default DashBoardIndex;
